/**
 * A mensagem que o servidor mandou — ou uma que sirva.
 *
 * ── Por que isto existe ───────────────────────────────────────────────────
 *
 * Onze lugares faziam `alert('Erro ao salvar. Tente novamente.')`, jogando
 * fora o corpo da resposta. Com os limites de tamanho no servidor, isso virou
 * o pior tipo de erro que existe: a pessoa colava um texto longo, recebia
 * "Tente novamente", tentava de novo, e falhava igual — porque o texto dela
 * continuava longo e nada disse isso.
 *
 * A mensagem certa existe, chega na resposta, e o código a descartava na
 * linha seguinte.
 *
 * ── Por que ainda há um texto de reserva ──────────────────────────────────
 *
 * Nem toda falha vem com corpo: rede caindo, servidor hibernando no Render,
 * timeout. Nesses casos não há mensagem do servidor porque não houve servidor.
 * O texto de reserva é do CHAMADOR, para dizer o que ele estava tentando —
 * "não consegui salvar" é mais útil que "erro".
 */
export const mensagemDeErro = (erro: unknown, reserva: string): string => {
  const e = erro as { response?: { data?: { error?: unknown }; status?: number } };
  const doServidor = e?.response?.data?.error;

  if (typeof doServidor === 'string' && doServidor.trim()) return doServidor;

  // 429 sem corpo: o rate limit sempre manda mensagem, mas um proxy no meio
  // pode comê-la. Melhor dizer o que aconteceu do que cair na reserva genérica.
  if (e?.response?.status === 429) return 'Muitas requisições seguidas. Espere um pouco.';
  if (e?.response?.status === 413) return 'O texto ou arquivo é grande demais.';

  return reserva;
};
